import { render, staticRenderFns } from "./card-coin-product.vue?vue&type=template&id=50a9cbd0"
import script from "./card-coin-product.vue?vue&type=script&lang=js"
export * from "./card-coin-product.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports